module.exports = __webpack_public_path__ + "static/media/29FUNOV1.1f2ff080.jpg";